import { TagType } from "../../../../constants";
import { useCreateExerciseTag } from "./useCreateExerciseTag";
import { useUpdateExerciseTag } from "./useUpdateExerciseTag";
import { useCreateClientTag } from "../../../coach-clients-tags/mutations/useCreateClientTag";
import { useUpdateClientTag } from "../../../coach-clients-tags/mutations/useUpdateClientTag";
import {
  ICreateExerciseTagCommand,
  ICreateTagCommand,
  IUpdateTagCommand,
} from "@growth-machine-llc/stridist-api-client";
import { MutateOptions } from "@tanstack/react-query";

interface IUpsertTagProps {
  tagType: TagType;
  id?: number;
}

type UpsertTagFn = (
  variables:
    | ICreateTagCommand
    | IUpdateTagCommand
    | ICreateExerciseTagCommand
    | IUpdateTagCommand,
  options?: MutateOptions<any, any, any>,
) => void;

export const useUpsertTag = ({
  tagType,
  id,
}: IUpsertTagProps): {
  mutate: UpsertTagFn;
  isPending: boolean;
} => {
  const createExerciseTag = useCreateExerciseTag();
  const updateExerciseTag = useUpdateExerciseTag();

  const createClientTag = useCreateClientTag();
  const updateClientTag = useUpdateClientTag();

  const isUpdate = !!id;

  switch (tagType) {
    case TagType.EXERCISE:
      return isUpdate ? updateExerciseTag : createExerciseTag;
    case TagType.CLIENT:
      return isUpdate ? updateClientTag : createClientTag;
    default:
      throw new Error(`Unsupported tag type: ${tagType}`);
  }
};
